export class Url {
  static getSemanticString(value: string) {
    return value
      .replace(/(\s+|\/)/g, '-')
      .replace(/[,.()]/g, '')
      .replace(/[-]{2,}/g, '-')
      .toLowerCase();
  }

  static decodeUrl(url: string) {
    return decodeURIComponent(url).replace(/^\//, '').replace(/\/$/, '');
  }
}
